import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CredentialsService } from '@core/services/credentials.service';

const routes = {
  legal: () => `/org/sgs/lookup/legal`,
  accept: () => '/org/sgs/profile/accept-tnc',
};

export interface LegalPolicy {
  url?: string;
  fileUrl?: string;
  link?: string;
  version?: number;
}

export interface LegalPoliciesResponse {
  termsAndConditions: LegalPolicy;
  privacyPolicy: LegalPolicy;
}

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  constructor(
    private httpClient: HttpClient,
    private credentialsService: CredentialsService,
  ) {}

  getLegalPolicies(): Observable<LegalPoliciesResponse> {
    return this.httpClient.get<LegalPoliciesResponse>(routes.legal());
  }

  getTerms(): Observable<LegalPolicy> {
    return this.getLegalPolicies().pipe(map((res) => res.termsAndConditions));
  }

  getPrivacyPolicy(): Observable<LegalPolicy> {
    return this.getLegalPolicies().pipe(map((res) => res.privacyPolicy));
  }

  accept(version: number): Observable<unknown> {
    return this.httpClient.post(
      routes.accept(),
      { version },
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.credentialsService.credentials.token}`,
        }),
      },
    );
  }
}
